import { Box, Button, Slide, SvgIcon, useMediaQuery } from "@mui/material";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { LargeText } from "components/typography";
import {
  clearHighlightMarkerLocation,
  selectLotLocationsFiltered,
  setHighlightedMarkerLocation,
} from "features/lotLocations/lotLocationsSlice";
import { getFirstImage, getFirstImageThumbnail } from "hooks/useFirstImage";
import { DeleteSmall } from "icons";
import "leaflet/dist/leaflet.css";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Virtuoso } from "react-virtuoso";
import HolzpolterInfoSmall from "./HolzpolterInfoSmall";
import styles from "./LosSectionSmall.module.css";
export default function LosSuche() {
  const [expanded, setExpanded] = useState(false);
  const lotLocationOffers = useAppSelector(selectLotLocationsFiltered);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const matches600 = useMediaQuery('(max-width: 600px)');
  const matches700 = useMediaQuery('(max-width: 700px)');

  const highlightMarker = (data: any) => {
    dispatch(setHighlightedMarkerLocation(data[0]));
  };
  const clearHighlightMarker = () => {
    dispatch(clearHighlightMarkerLocation());
  };
  const virtuosoRef = useRef<any>(null);

  // console.log(lotLocationOffers.length)
  return (
    <Box sx={{
      position: "absolute",
      width: "100%",
      borderRadius: "13px 13px 0px 0px",
      zIndex: 1101,
      bottom: 0,
      display: "flex",
      justifyContent: "center",
      flexDirection: "column",
      height: expanded ? "75%" : "5%"
    }}>
      <Box sx={{ display: "flex", position: "relative", zIndex: 1102, backgroundColor: "white", alignItems: "center", width: "100%" }}>
        <Button
          sx={{ pt: 2, zIndex: 1102, width: "100%" }}
          onClick={() => {
            setExpanded(!expanded);
          }}
        >
          <LargeText fWeight="bold" color="#072D26">
            {lotLocationOffers.length > 100 ? "Mehr als 100" : lotLocationOffers.length} Holzpolter
          </LargeText>
        </Button>
        {expanded ? (
          <SvgIcon
            sx={{ zIndex: 1102, ml: "auto", pr: 2 }}
            onClick={() => {
              setExpanded(!expanded);
            }}
          >
            <DeleteSmall />
          </SvgIcon>
        ) : null}
      </Box>
      <Slide
        direction="up"
        in={expanded}
        timeout={{
          enter: matches600 ? 400 : 200,
          exit: matches600 ? 200 : 100,
        }}
      >
        <Box
          sx={{
            zIndex: 1100,
            width: "100%",
            maxHeight: "95vh",
            height: "100%",
            alignSelf: "bottom",
            overflow: "hidden",
            display: { xs: "block", lg: "none" },
            backgroundColor: "white",

          }}
        >
          <Virtuoso
            style={{
              overflowY: "auto",
              width: "100%",
              height: "100%",
              paddingRight: "17px",
              boxSizing: "content-box",
            }}
            ref={virtuosoRef}
            totalCount={lotLocationOffers.length}
            itemContent={(index) => {
              const lotLocationOffer = lotLocationOffers[index];
              const locationImage = matches700 ? getFirstImageThumbnail(lotLocationOffer.images) : getFirstImage(lotLocationOffer.images);
              return (
                <Box className={styles.losSectionSmallDiv}
                  key={index}
                  sx={{
                    mt: "10px",
                    padding: "15px 15px",

                  }}
                  onMouseDown={() => {
                    highlightMarker(lotLocationOffer.wood_piles);
                  }}
                  onMouseUp={() => {
                    clearHighlightMarker();
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      overflow: "hidden",
                      height: "80%",
                      width: "inherit",
                      flexDirection: "column",
                      "&:hover img": {
                        transform: "scale(1.25)",
                        transformOrigin: "50% 50%",
                        transition: "transform 0.4s",

                      },
                    }}
                    onClick={() => navigate(`${lotLocationOffer.id}`)}
                  >
                    <Box
                      component="div"
                      sx={{
                        overflow: "hidden",
                        width: "100%",
                        mt: 2,
                        maxWidth: "80%"
                      }}
                    >
                      <Box
                        component="img"
                        sx={{
                          aspectRatio: "4/3",
                          objectFit: "cover",
                          width: "inherit",
                          maxWidth: "100%",
                          overflow: "hidden",
                        }}
                        alt="image"
                        src={locationImage}
                      />
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        width: "100%",
                        position: "relative",
                        height: "inherit",
                        maxWidth: "80%"
                      }}
                    >
                      <HolzpolterInfoSmall lotInformation={lotLocationOffer} />
                    </Box>
                  </Box>
                </Box>

              );
            }}
          />
        </Box>
      </Slide>
    </Box>
  );
}
